import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, finalize, map, of, switchMap, tap } from 'rxjs';
import * as fromActions from './profile.actions';
import { CrudLessorLibService } from '../../services/crud-lessor/crud-lessor-lib.service';
import { Store } from '@ngrx/store';
import { State } from './profile.reducer';
import { AlertController } from '@ionic/angular';
import { Router } from '@angular/router';

@Injectable()
export class ProfileEffects {
  private actions$ = inject(Actions);
  private crudLessorLibService = inject(CrudLessorLibService);
  private store = inject(Store);
  private alertController = inject(AlertController);
  private router = inject(Router);

  registerSportSenter$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.registerProfile),
      tap(() => this.showLoader()),
      switchMap(({ profileState }) =>
        this.crudLessorLibService.create(profileState).pipe(
          map(() => {
            this.presentAlert('Seja bem vindo ao Cragvia!', 'Para começar verifique o seu email.');
            this.router.navigate(['auth']);
            this.store.dispatch(fromActions.resetStore());
            return fromActions.registerProfileSuccefully({
              newState: {} as State,
            });
          }),
          catchError((error) => {
            this.presentAlert('Erro ao cadastrar.', error?.message ?? 'Tente mais tarde.');
            return of(fromActions.registerProfileFailed({ error }));
          }),
          finalize(() => this.hideLoader())
        )
      )
    )
  );

  verifyEmail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.verifyEmail),
      tap(() => this.showLoader()),
      switchMap(({ email }) =>
        this.crudLessorLibService.verifyEmail(email).pipe(
          map((isEmailValid) => {
            return fromActions.verifyEmailSuccefully({ isEmailValid });
          }),
          catchError((error) => {
            return of(fromActions.verifyEmailFailed({ error }));
          }),
          finalize(() => this.hideLoader())
        )
      )
    )
  );

  verifyUserName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.verifyUserName),
      tap(() => this.showLoader()),
      switchMap(({ userName }) =>
        this.crudLessorLibService.verifyUserName(userName).pipe(
          map((isUserNameValid) => {
            return fromActions.verifyUserNameSuccefully({ isUserNameValid });
          }),
          catchError((error) => {
            return of(fromActions.verifyUserNameFailed({ error }));
          }),
          finalize(() => this.hideLoader())
        )
      )
    )
  );

  private showLoader() {
    this.store.dispatch(fromActions.setLoading({ loading: true }));
  }

  private hideLoader() {
    this.store.dispatch(fromActions.setLoading({ loading: false }));
  }

  async presentAlert(subHeader: string, message: string) {
    const alert = await this.alertController.create({
      header: '',
      subHeader,
      message,
      buttons: ['OK'],
    });

    await alert.present();
  }
}
